import {
  EXPORT_LEADS_ON_EMAIL,
  EXPORT_LEADS_ON_EMAIL_SUCCESS,
  EXPORT_LEADS_ON_EMAIL_ERROR,
  EXPORT_CALLS_ON_EMAIL,
  EXPORT_CALLS_ON_EMAIL_SUCCESS,
  EXPORT_CALLS_ON_EMAIL_ERROR,
  EXPORT_PROSPECTS_ON_EMAIL,
  EXPORT_PROSPECTS_ON_EMAIL_SUCCESS,
  EXPORT_PROSPECTS_ON_EMAIL_ERROR,
  EXPORT_INVOICES_ON_EMAIL,
  EXPORT_INVOICES_ON_EMAIL_SUCCESS,
  EXPORT_INVOICES_ON_EMAIL_ERROR,
  EXPORT_RECEIPTS_ON_EMAIL,
  EXPORT_RECEIPTS_ON_EMAIL_SUCCESS,
  EXPORT_RECEIPTS_ON_EMAIL_ERROR
} from "./actionTypes"

export const exportLeadsOnEmail = (analytics, product_type) => {
  return {
    type: EXPORT_LEADS_ON_EMAIL,
    payload: analytics,
    product_type: product_type
  }
}

export const exportLeadsOnEmailSuccess = (response) => {
  return {
    type: EXPORT_LEADS_ON_EMAIL_SUCCESS,
    payload: response
  }
}

export const exportLeadsOnEmailError = (error) => {
  return {
    type: EXPORT_LEADS_ON_EMAIL_ERROR,
    payload: error,
  }
}

export const exportCallsOnEmail = (analytics, product_type) => {
  return {
    type: EXPORT_CALLS_ON_EMAIL,
    payload: analytics,
    product_type: product_type
  }
}

export const exportCallsOnEmailSuccess = (response) => {
  return {
    type: EXPORT_CALLS_ON_EMAIL_SUCCESS,
    payload: response
  }
}

export const exportCallsOnEmailError = (error) => {
  return {
    type: EXPORT_CALLS_ON_EMAIL_ERROR,
    payload: error,
  }
}

export const exportProspectsOnEmail = (analytics, product_type) => {
  return {
    type: EXPORT_PROSPECTS_ON_EMAIL,
    payload: analytics,
    product_type: product_type
  }
}

export const exportProspectsOnEmailSuccess = (response) => {
  return {
    type: EXPORT_PROSPECTS_ON_EMAIL_SUCCESS,
    payload: response
  }
}

export const exportProspectsOnEmailError = (error) => {
  return {
    type: EXPORT_PROSPECTS_ON_EMAIL_ERROR,
    payload: error,
  }
}

export const exportInvoicesOnEmail = (analytics) => {
  return {
    type: EXPORT_INVOICES_ON_EMAIL,
    payload: analytics,
  }
}

export const exportInvoicesOnEmailSuccess = (response) => {
  return {
    type: EXPORT_INVOICES_ON_EMAIL_SUCCESS,
    payload: response
  }
}

export const exportInvoicesOnEmailError = (error) => {
  return {
    type: EXPORT_INVOICES_ON_EMAIL_ERROR,
    payload: error,
  }
}

export const exportReceiptsOnEmail = (analytics) => {
  return {
    type: EXPORT_RECEIPTS_ON_EMAIL,
    payload: analytics,
  }
}

export const exportReceiptsOnEmailSuccess = (response) => {
  return {
    type: EXPORT_RECEIPTS_ON_EMAIL_SUCCESS,
    payload: response
  }
}

export const exportReceiptsOnEmailError = (error) => {
  return {
    type: EXPORT_RECEIPTS_ON_EMAIL_ERROR,
    payload: error,
  }
}
